import React, { useEffect } from "react";
import { ConnectedProps, connect } from "react-redux";
import {
  actions as transactionActions,
  transactionsSelector,
} from "reducers/transactions";
import { Transaction } from "pages/transaction/Transaction";
import { useLocation } from "react-router-dom";
import { parseQueryParams } from "utils/utils";
import moment from "moment";
import { AppDispatch, RootState } from "store";
import {
  TransactionContainerPropsType,
  URLTransactionContainerType,
} from "./types";
import { FilterTransactionsType } from "sagas/types/transactions";
import { SetFilterType } from "reducers/types/transaction";
import { DATE_FORMATS } from "utils/constants";
import { actions as notificationActions } from "reducers/notification";
import { NotificationStateType } from "reducers/types/notification";
import { BulkCancelTransactionType } from "../../sagas/types/transactions";
import { actions as regionsActions } from "reducers/regions";

const TransactionContainer = (
  props: TransactionContainerPropsType & ConnectorProps
): JSX.Element => {
  const params = useLocation();
  useEffect(() => {
    props.toggleDetailTransactionModal(false);

    const filters: URLTransactionContainerType = parseQueryParams(
      params.search
    );
    filters.maxSla &&
      (filters.date = {
        from: moment(
          filters.minSla,
          DATE_FORMATS.shortISODate
        ).format(DATE_FORMATS.extraShortDate),
        until: moment(
          filters.maxSla,
          DATE_FORMATS.shortISODate
        ).format(DATE_FORMATS.extraShortDate),
      });
    filters.regions = filters.regions ? decodeURIComponent(filters.regions) : undefined;
    filters.state = filters.state ? decodeURIComponent(filters.state) : undefined;
    props.getTransactions({ ...filters, offset: 0 });
    props.setFilters(filters || {});
    if (filters?.regions?.split(",").length === 1) {
      props.getWorkzones(filters.regions.split(",")[0]);
    }
    // eslint-disable-next-line
  }, []);

  return <Transaction {...props} testId="transactions" />;
};

const mapStateToProps = (state: RootState) => ({
  transactions: transactionsSelector(state).transactions,
  isExportDisabled: transactionsSelector(state).exportDisabled,
  filters: transactionsSelector(state).filters,
  limit: transactionsSelector(state).limit,
  seeMore: transactionsSelector(state).seeMore,
  transactionsSelected: transactionsSelector(state).transactionsSelected,
  errorTransactions: transactionsSelector(state).errorTransactions,
  masiveCancelationModalOpen:
    transactionsSelector(state).masiveCancelationModalOpen,
  detailTransactionModalOpen:
    transactionsSelector(state).detailTransactionModalOpen,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getTransactionsExportRequest: (
    params: FilterTransactionsType,
    element: HTMLElement
  ) => {
    element.blur();
    dispatch(transactionActions.getTransactionsExportRequest(params));
  },
  getTransactions: (params: FilterTransactionsType) => {
    dispatch(transactionActions.getTransactionsRequest(params));
  },
  getWorkzones: (regionId: string) => {
    dispatch(regionsActions.getWorkzonesFetch(regionId));
  },
  reset: () => {
    dispatch(transactionActions.reset());
  },
  setFilters: (filters: SetFilterType) => {
    dispatch(transactionActions.setTransactionFilters(filters));
  },
  getMoreTransactions: (params: FilterTransactionsType) => {
    dispatch(transactionActions.getMoreTransactionsRequest(params));
  },
  toggleDetailTransactionModal: (show: boolean) => {
    dispatch(transactionActions.toggleDetailTransactionModal(show));
  },
  toggleMasiveCancelationModal: (show: boolean) => {
    dispatch(transactionActions.toggleMasiveCancelationModal(show));
  },
  showNotification: (content: NotificationStateType) => {
    dispatch(notificationActions.showNotification(content));
  },
  cancelTransactions: (transactions: BulkCancelTransactionType) => {
    dispatch(transactionActions.postCancelTransactionsRequest(transactions));
  },
  resetErrorTransactions: () => {
    dispatch(transactionActions.resetErrorTransactions());
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(TransactionContainer);
